<script setup lang="ts">
import { LeftAsideProps } from "./LeftAside.props"
import { sm } from "~/utils/breakpoints"

const props = withDefaults(defineProps<LeftAsideProps>(), {
  columns: 5
})

const isHeaderVisible = useState("header")

const positionTop = computed(() => {
  return props.headerAlertExist ? (sm ? 180 : 192) : sm ? 150 : 160
})

const { height } = useWindowSize()
const containerHeight = computed(() =>
  Math.max(0, height.value - positionTop.value)
)
</script>

<template>
  <div class="md:block">
    <Transition name="opacity">
      <UtilsOverlayModal v-if="isOpen" />
    </Transition>
    <Transition name="slide-left">
      <div
        v-if="isOpen"
        class="grid-standard fixed right-0 z-[999] w-full"
        :style="{ height: `${containerHeight}px`, top: `${positionTop}px` }"
      >
        <div
          class="
            bg-white
            relative
            -mx-4
            h-full
            overflow-y-auto
            pr-4
            md:col-end-13
            md:-mr-[71px]
            md:ml-0
            md:pr-[71px]
            lg:-mr-[228px]
            lg:pr-[228px]
          "
          :class="`col-span-${columns}`"
        >
          <slot />
        </div>
      </div>
    </Transition>
  </div>
</template>
